import React, { Component } from 'react';
import Parse from 'parse';

export default class SearchFilter extends Component {
  constructor(props) {
      super(props);
  }

  onChange = (e) => {
    this.props.updateValue(this.props.targetKey,e.target.value)
  }
  formatTrueFalse = (value) =>{
    var formattedValue = "";
    if(value === true){
      formattedValue = "Yes"
    } else if(value === false){
      formattedValue = "No"
    } else{
      formattedValue = value
    }
    return formattedValue
  }

  render() {
    return (
      <div className="filter-select" style={{flexGrow:1, padding:"4px"}}>
        <h4 style={{margin:0, textAlign:"center",color:"#fff"}}>{this.props.title}</h4>
        <select value={this.props.value} onChange={this.onChange}>
          <option value={undefined}>{"All"}</option>
          {this.props.options && this.props.options.map((data,index) => {
            return(
              <option value={typeof data == "boolean" ? this.formatTrueFalse(data) : data}>{typeof data == "boolean" ? this.formatTrueFalse(data) : data}</option>
            )
          })}
        </select>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/searchFilter.js